import { Component } from 'react';

class AdditionalBox extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="table-additional-view">
                    <div className="table-additional-view-btns">
                        <button
                            className={`table-additional-view-btn ${
                                (!this.props.view || this.props.view === 1) && 'active'
                            }`}
                            onClick={() => this.chooseView(1)}
                        >
                            Nested View
                        </button>
                        <button
                            className={`table-additional-view-btn ${
                                this.props.view === 2 && 'active'
                            }`}
                            onClick={() => this.chooseView(2)}
                        >
                            2nd Level
                        </button>
                        <button
                            className={`table-additional-view-btn ${
                                this.props.view === 3 && 'active'
                            }`}
                            onClick={() => this.chooseView(3)}
                        >
                            3rd Level
                        </button>
                        {this.props.hasTree && (
                            <button
                                type="button"
                                className="table-additional-view-btn"
                                onClick={() => {
                                    // check if "all categories" is open or not
                                    if (!this.props.tree.state.ids.includes('all_categories')) {
                                        this.props.tree.fns.onToggleById('all_categories');
                                    }

                                    // minus 1 because ids doesn't include 'all_categoris'
                                    // this one for closing all
                                    if (
                                        this.props.tree.state.ids.length - 1 ===
                                        this.props.ids.current?.length
                                    ) {
                                        return this.props.ids.current.forEach((id) =>
                                            this.props.tree.fns.onToggleById(id),
                                        );
                                    }

                                    //this one for opening all
                                    this.props.ids.current?.forEach((id) => {
                                        if (!this.props.tree.state.ids.includes(id)) {
                                            this.props.tree.fns.onToggleById(id);
                                        }
                                    });
                                }}
                            >
                                {this.props.tree.state.ids.length - 1 ===
                                this.props.ids.current?.length
                                    ? 'Collaps All'
                                    : 'Expand All'}
                            </button>
                        )}
                    </div>
                </div>
            </>
        );
    }
}

export default AdditionalBox;
